import { BaseModalComponent } from './../base/base-modal.component';
import { FormGenModel } from './../../../../../shared/models/form-gen.model';
import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { ModalController } from '@ionic/angular';

export const NAME_LIST: FormGenModel[] = [
  { label: 'PREFIX', value: '0', required: false, formArray: 'prefix', id: 'name-prefix' },
  { label: 'FAMILY', value: 'family', required: true, id: 'name-family' },
  { label: 'GIVEN', value: '0', required: true, formArray: 'given', id: 'name-given' },
  { label: 'SUFFIX', value: '0', required: false, formArray: 'suffix', id: 'name-suffix' }
];

export function getNameFormGroup(): FormGroup {
  return new FormGroup({
    use: new FormControl('official'),
    prefix: new FormArray([
      new FormControl('', Validators.pattern('([a-zA-ZáéúőóüöÁÉÚŐÓÜÖà-ŽőŐ0-9]+)\\.?'))
    ]),
    // tslint:disable-next-line: quotemark
    family: new FormControl('', [Validators.required, Validators.pattern("[a-zA-ZáéúőóüöÁÉÚŐÓÜÖà-ŽőŐ0-9 ,.'-]+")]),
    given: new FormArray([
      // tslint:disable-next-line: quotemark
      new FormControl('', [Validators.required, Validators.pattern("[a-zA-ZáéúőóüöÁÉÚŐÓÜÖà-ŽőŐ0-9 ,.'-]+")])
    ]),
    suffix: new FormArray([
      // tslint:disable-next-line: quotemark
      new FormControl('', Validators.pattern("[a-zA-ZáéúőóüöÁÉÚŐÓÜÖà-ŽőŐ0-9 ,.'-]+"))
    ]),
    text: new FormControl()
  });
}

@Component({
  selector: 'inc-name',
  templateUrl: './../base/base-modal.component.html'
})
export class NameComponent extends BaseModalComponent {
  title = 'NAME_L';
  formGenList = NAME_LIST;

  constructor(modalController: ModalController) {
    super(modalController);
    this.reset(getNameFormGroup());
  }

  save() {
    this.createNameText();
    this.baseSave({ value: { name: this.form } });
  }

  createNameText() {
    if (!this.form.value.family || !this.form.value.given[0]) {
      return;
    }
    this.form.controls.prefix.setValue([this.form.value.prefix[0].trim()]);
    this.form.controls.family.setValue(this.form.value.family.trim());
    this.form.controls.given.setValue([this.form.value.given[0].trim()]);
    this.form.controls.suffix.setValue([this.form.value.suffix[0].trim()]);
    const nameText = (this.form.value.prefix[0] ? this.form.value.prefix[0] + ' ' : '') +
      this.form.value.family + ' ' + this.form.value.given[0] + (this.form.value.suffix[0] ? ' ' + this.form.value.suffix[0] : '');
    this.form.controls.text.setValue(nameText);
  }
}
